export function TacticalChartIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Frame */}
      <rect x={4} y={5} width={16} height={13} rx={2} />
      {/* Grid line */}
      <path d="M8 10h9.5" strokeDasharray="2 2" />
      {/* Trend line */}
      <path d="M7 15l3-4 2.5 2 3.5-5 2 3" />
      {/* Target dot */}
      <circle cx={18} cy={11} r={0.9} />
    </svg>
  );
}



